import updateTreeState from './common/updateTreeState';

const updateTree = (
  prevState,
  { treeId, models, filter, context, adapter, plugins },
) => {
  let treeState = prevState[treeId];

  if (!treeState) {
    return prevState;
  }

  if (
    context !== treeState.context ||
    filter !== treeState.filter ||
    models !== treeState.inputModels
  ) {
    treeState = {
      ...treeState,
      inputModels: models,
      filter,
      context,
    };
  }

  const { lazyLoading } = plugins;
  let incomingModels = models || [];
  if (lazyLoading) {
    incomingModels = incomingModels.concat(
      lazyLoading.collectLazyLoadedModels(treeState),
    );
  }

  return {
    ...prevState,
    [treeId]: updateTreeState(treeState, incomingModels, { adapter, plugins }),
  };
};
export default updateTree;
